'use strict';

import template from './info_menu.html';

const controller = [
  '$state',
  '$element',
  'breakpoint',
  'userModel',

  function ($state, $element, breakpoint, userModel) {
    var isExpanded;

    this.userModel = userModel;

    this.$state = $state;

    this.toggle = function ($event) {
      var targetTag = $event.target && $event.target.tagName;
      var shouldIgnoreClick = (breakpoint() === 'desktop' || (targetTag === 'A' && !isExpanded));

      if (!shouldIgnoreClick) {
        this.isExpanded = !this.isExpanded;
        isExpanded = !isExpanded;
      }

    };
  }
];
const saInfoMenu = function () {
  return {
    template: template,
    replace: true,
    scope: {
      isStatic: '='
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
};

export default saInfoMenu;



// WEBPACK FOOTER //
// ./app/src/modules/info/info_menu.component.js